import { IconChevronLeft } from '@tabler/icons-react';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { CloseButton } from '@zorro/design-system/v2/CloseButton';
import { useDrawerFooter } from '@zorro/design-system/v2/Drawer';
import { Title } from '@zorro/design-system/v2/Title';
import { Box, Group, Icon, Stack } from '@zorro/web/design-system';
import { ReactNode, useCallback } from 'react';

type Props = {
  title: string;
  onClose: () => void;
  onBack?: () => void;
  footer: ReactNode;
  children: ReactNode;
};

export const AppLayoutMenuPage = ({
  title,
  onClose,
  onBack,
  footer,
  children,
}: Props) => {
  const paddedFooter = <Box p="var(--space-12)">{footer}</Box>;
  const isFooterInDrawer = useDrawerFooter(paddedFooter);

  // The view swap unmounts the control that had focus; hand it to the new heading.
  const focusOnMount = useCallback(
    (node: HTMLHeadingElement | null) => node?.focus(),
    []
  );

  return (
    <>
      <Group wrap="nowrap" justify="space-between" mb="var(--space-16)">
        {onBack && (
          <ActionIcon aria-label="Back" onClick={onBack}>
            <Icon icon={IconChevronLeft} />
          </ActionIcon>
        )}
        <CloseButton aria-label="Close" ml="auto" onClick={onClose} />
      </Group>

      <Stack gap="var(--space-20)" pb="var(--space-24)">
        <Title order={2} ref={focusOnMount} tabIndex={-1}>
          {title}
        </Title>
        {children}
      </Stack>

      {!isFooterInDrawer && paddedFooter}
    </>
  );
};
